import { apiClient, unwrap } from './client'
import type { ConfigurationResponse } from './types'

/**
 * First domain on the generated types. Add further domains as sibling modules
 * (one file per backend tag) and point the store thunks at them.
 */
export const getConfiguration = (): Promise<ConfigurationResponse> => unwrap(apiClient.GET('/api/1/configuration'))
